import React, { Component } from "react";
import { Helmet } from "react-helmet";

export const SITE_NAME = "Fernan de Dios";
export const SITE_URL = "https://www.fernandedios.com";
export const DEFAULT_IMAGE = `${SITE_URL}/img/share.jpg`;

class SEO extends Component {
  render() {
    const {
      title,
      description,
      path = "/",
      image = DEFAULT_IMAGE,
      type = "website",
      jsonLd,
    } = this.props;

    const url = `${SITE_URL}${path}`;
    const fullTitle = title.includes(SITE_NAME)
      ? title
      : `${title} | ${SITE_NAME}`;

    return (
      <Helmet>
        <title>{fullTitle}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />

        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content={type} />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={image} />
        <meta property="og:site_name" content={SITE_NAME} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />

        {jsonLd &&
          (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((schema, index) => (
            <script
              key={`jsonld-${index}`}
              type="application/ld+json"
            >
              {JSON.stringify(schema)}
            </script>
          ))}
      </Helmet>
    );
  }
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map(({ name, path }, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name,
      item: `${SITE_URL}${path}`,
    })),
  };
}

export default SEO;
